import { ppData } from '../configs/ppData.config';
import { layoutValues, sizeValues } from '../configs/options';
const { title, artistCollection, colorCollections, styleCollection, mainCollection } = ppData;
const [layouts] = layoutValues;
const [sizes] = sizeValues;
const mainCollectionTitle = mainCollection?.title;
const { minSize, maxSize } = (() => {
    if (sizes.length < 1)
        return { minSize: '', maxSize: '' };
    let minSize = sizes[0].label;
    let maxSize = minSize;
    let min = +minSize.slice(0, minSize.indexOf('"'));
    let max = min;
    sizes.forEach(({ label }) => {
        const width = +label.slice(0, minSize.indexOf('"'));
        if (width < min) {
            min = width;
            minSize = label;
        }
        else if (width > max) {
            max = width;
            maxSize = label;
        }
    });
    return { minSize, maxSize };
})();
export const getDynamicSEODescription = (kw1) => {
    return [
        `Finding the perfect canvas print or piece of wall art can transform your entire interior. Discover our stunning ${title} ${kw1}${artistCollection !== undefined ? `by ${artistCollection.title}` : ''}.`,
        `This high-quality, ready-to-hang piece of ${colorCollections[0]?.title}${colorCollections[1] !== undefined ? ` and ${colorCollections[1].title}` : ''} ${styleCollection?.title ?? ''} ${mainCollectionTitle ?? ''} ${kw1} comes in a wide variety of layouts. Browse sizes ranging from ${minSize} to ${maxSize}.`,
        `Explore adaptable arrangements to fit your unique space, including ${layouts[0].label}${layouts[1] !== undefined ? `, ${layouts[1].label}` : ''}${layouts[2] !== undefined ? `, and ${layouts[2].label}` : ''} prints. Instantly create a daring, designer home.`
    ];
};
